import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../utils/CustomBaseQuery/customBaseQuery";
import {
  ADD_UPDATE_GLOBAL_LIST,
  GET_ACTIVITY_LOG,
  GET_ALL_EVENTS,
  GET_ALL_TAGS,
  GET_COMPARISON_LOG,
  GET_GLOBAL_LIST,
} from "../../utils/constants"; // ✅ Make sure GET_EVENTS constant exists
import { getUserToken } from "../../utils/utilityFunctions/localServices";

export const ActivityApis = createApi({
  reducerPath: "activityLog",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    // POST - Fetch Activity Logs
    fetchActivityLog: builder.mutation({
      query: (payload) => ({
        url: `${GET_ACTIVITY_LOG}`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
        body: payload,
      }),
    }),

    // GET - Fetch Events (only sends token)
    fetchEvents: builder.query({
      query: () => ({
        url: `${GET_ALL_EVENTS}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
        },
      }),
    }),
    getGlobalDropdown: builder.query({
      query: () => ({
        url: `${GET_GLOBAL_LIST}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    addUpdateGlobalList: builder.mutation({
      query: ({ id, ...payload }) => ({
        url: id ? `${ADD_UPDATE_GLOBAL_LIST}/${id}` : `${ADD_UPDATE_GLOBAL_LIST}`,
        method: id ? "PUT" : "POST",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
        body: payload,
      }),
    }),
    getAllTags: builder.query({
      query: () => ({
        url: `${GET_ALL_TAGS}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    getAllComparisonLogs: builder.query({
      query: ({ id }) => ({
        url: `${GET_COMPARISON_LOG}/${id}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const {
  useFetchActivityLogMutation,
  useFetchEventsQuery,
  useGetGlobalDropdownQuery,
  useAddUpdateGlobalListMutation,
  useGetAllTagsQuery,
  useGetAllComparisonLogsQuery,
} = ActivityApis;
